import routes from "constants/routes"
import { stringMerger } from "utils"

export const reportsMerger = (route) => {
    return stringMerger(routes.REPORTS.HOME, route)
}